import axios from '@/lib/AxApi';

export default {
  getTehnicalLabs(params, cb)
  {
    params.type = 'technicallab';
    axios.get('/rest/User_companies/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  saveTehnicalLab(params, cb)
  {
    params.type = 'technicallab';
    if(typeof params.id != 'undefined' && params.id != '')
    {
      axios.post('/rest/User_companies/updateRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
    else
    {
      axios.post('/rest/User_companies/insertRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
  },
  deleteTehnicalLab(params, cb)
  {
    axios.post('/rest/User_companies/deleteRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/tehnicallabs.js